import { Select } from 'antd';
import { useState, useCallback, useEffect, useMemo } from 'react';
import { API } from '../api';
import { notifyError } from '../store/utils';

interface ProvinceSelectProps {
  value?: string;
  showSearch?: boolean;
  allowClear?: boolean;
  disabled?: boolean;
  province?: any;
  onChange?: (value: string) => void;
}

const ProvinceSelect: React.FC<ProvinceSelectProps> = ({
  value,
  showSearch,
  allowClear,
  disabled,
  province,
  onChange,
}) => {
  const [state, updateState] = useState<any[]>([]);

  const onSearch = useCallback(async (query: string) => {
    try {
      const { result } = await API.get({ apiVersion: 'api' })(`/address/province/list`);
      updateState(result?.data || []);
    } catch (error: any) {
      notifyError(error.message);
    }
  }, []);

  const loadFirst = useCallback(async () => {
    try {
      const { result } = await API.get({ apiVersion: 'api' })(
        `/address/province/list?page=1&size=10`
      );
      const list = result?.data || [];
      const check = list.filter((it: any) => it.no === province?.no);
      if (province && check.length) {
        updateState([...list, province]);
      } else {
        updateState(list);
      }
    } catch (error: any) {
      notifyError(error.message);
    }
  }, [province]);

  useEffect(() => {
    loadFirst();
  }, []);

  const options = useMemo(() => {
    return state.map((item: any) => {
      return {
        label: item.name,
        value: item.no,
      };
    });
  }, [state]);

  return (
    <Select
      placeholder="Аймаг хот сонгоно уу"
      showSearch={showSearch}
      allowClear={allowClear}
      //onSearch={(query: string) => onSearch(query)}
      onChange={onChange}
      options={options}
      value={value}
      disabled={disabled}
      optionFilterProp="label"
    />
  );
};

export default ProvinceSelect;
